import defineProperty from './_define_property';
defineProperty(Array, 'last', function () {
  return this[this.length - 1];
});